import React from 'react'
import SalesTeam from './components/SalesTeam'

const ContactUs: React.FC = () => {
    return <SalesTeam />
}

export default ContactUs
